// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.persona.RentalManagerUserPersonaLinkWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { RentalManagerGetPersonaLinkResponseDto } from '../..';

export const RentalManagerUserPersonaLinkWebApiHandler_getLink_Path = '/api/web/v1/users/persona/getLink';

/**
 * Get persona inquiry link for a user
 */
export const RentalManagerUserPersonaLinkWebApiHandler_getLink = (environment?: RentalManagerEnvironment) => {
  return frontEndRequestV2<never, never, RentalManagerGetPersonaLinkResponseDto>({
    endpoint: RentalManagerUserPersonaLinkWebApiHandler_getLink_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
